<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { getImportUploadLink } from '../../api/EnzianApi';
	import Modal from '../modal/Modal.svelte';
	import ModalHeader from '../modal/ModalHeader.svelte';
	import UploadField from './UploadField.svelte';

	interface Props {
		disableUpload?: boolean;
		uploadName: string;
		acceptedFileTypes: string;
		warnings?: string[] | null;
		downloadLink?: string | null;
		fileTypeCheck: (type: String) => Boolean;
		confirmFunction: (uploadName: string, objectName: string) => Promise<void>;
		header: string;
		uploadDescription: string;
		additionContent?: import('svelte').Snippet;
		addons?: import('svelte').Snippet;
		onModalClose: () => void;
	}

	let {
		disableUpload = false,
		uploadName,
		acceptedFileTypes,
		warnings = null,
		downloadLink = null,
		fileTypeCheck,
		confirmFunction,
		header,
		uploadDescription,
		additionContent,
		addons,
		onModalClose
	}: Props = $props();
</script>

<Modal {onModalClose}>
	{#snippet header()}
		<ModalHeader text={header} />
	{/snippet}
	{#snippet content()}
		<div class="flex flex-col gap-8" style="max-width: 760px;">
			<div>
				<p>{uploadDescription}</p>

				{@render additionContent?.()}

				{#if warnings && warnings.length > 0}
					<ul>
						{#each warnings as warning}
							<li>
								<p class="text-red dark:text-orange font-bold">{warning}</p>
							</li>
						{/each}
					</ul>
				{/if}

				{#if downloadLink}
					<br />
					<p>
						{$_('general.import.lbl_link') + ':'}
						<a class="text-secondary-200 dark:text-secondary-500" href={downloadLink}>Link</a>
					</p>
				{/if}
			</div>

			{@render addons?.()}
			<UploadField
				onUploadSuccess={() => onModalClose()}
				getUploadLink={getImportUploadLink}
				displayText={$_('general.import.lbl_upload_description')}
				{acceptedFileTypes}
				{uploadName}
				{disableUpload}
				{confirmFunction}
				{fileTypeCheck}
			></UploadField>
		</div>
	{/snippet}
</Modal>
